import {
  CalculatorResultsEmail,
  CalculatorResultsSubmission,
  EmailToContact,
  MailContact,
  NewContact,
} from '../types/MailingProps';

type MailingAction =
  | 'createContact'
  | 'notifyAcueductoOfInquiry'
  | 'confirmReceiptToContact'
  | 'sendCalculatorResults'
  | 'submitContactForm'
  | 'submitCalculatorResults'
  | 'sendEmail'
  | 'SendEmailToContact';

const postMailingAction = async (
  action: MailingAction,
  data: unknown,
  recaptchaToken?: string | null,
) => fetch('/api/mailing', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    action,
    data,
    recaptchaToken: recaptchaToken || undefined,
  }),
});

export const createContact = async (
  submittedData: NewContact,
  recaptchaToken?: string | null,
) => postMailingAction('createContact', submittedData, recaptchaToken);

export const notifyAcueductoOfInquiry = async (
  formData: MailContact,
  recaptchaToken?: string | null,
) => postMailingAction('notifyAcueductoOfInquiry', formData, recaptchaToken);

export const confirmReceiptToContact = async (
  formData: Pick<MailContact, 'email'> & Partial<Pick<MailContact, 'firstName'>>,
  recaptchaToken?: string | null,
) => postMailingAction('confirmReceiptToContact', formData, recaptchaToken);

export const sendCalculatorResults = async (
  formData: CalculatorResultsEmail,
  recaptchaToken?: string | null,
) => postMailingAction('sendCalculatorResults', formData, recaptchaToken);

export const submitContactForm = async (
  formData: MailContact,
  recaptchaToken?: string | null,
) => postMailingAction('submitContactForm', formData, recaptchaToken);

export const submitCalculatorResults = async (
  formData: CalculatorResultsSubmission,
  recaptchaToken?: string | null,
) => postMailingAction('submitCalculatorResults', formData, recaptchaToken);

// Backwards-compatible client helpers. Old bundles can still call these action
// names, but new public flows should use the composite submit* actions.
export const sendEmail = async (
  formData: MailContact,
  recaptchaToken?: string | null,
) => postMailingAction('sendEmail', formData, recaptchaToken);

export const sendEmailToContact = async (
  formData: EmailToContact,
  recaptchaToken?: string | null,
) => postMailingAction('SendEmailToContact', formData, recaptchaToken);
